const dataAssetOverviewFilterKeys = ["from", "to", "user"];

export function getFiltersFromLocationSearch(search) {
  const searchParams = new URLSearchParams(search);
  const filters = Object.fromEntries(
    dataAssetOverviewFilterKeys.map(key => [key, searchParams.get(key)]),
  );

  return filters;
}
